var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSectionCloseHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M13.3003413,4.70648464 C13.0341297,4.44027304 12.6040956,4.44027304 12.337884,4.70648464 L9,8.03754266 L5.66211604,4.6996587 C5.39590444,4.4334471 4.96587031,4.4334471 4.6996587,4.6996587 C4.4334471,4.96587031 4.4334471,5.39590444 4.6996587,5.66211604 L8.03754266,9 L4.6996587,12.337884 C4.4334471,12.6040956 4.4334471,13.0341297 4.6996587,13.3003413 C4.96587031,13.5665529 5.39590444,13.5665529 5.66211604,13.3003413 L9,9.96245734 L12.337884,13.3003413 C12.6040956,13.5665529 13.0341297,13.5665529 13.3003413,13.3003413 C13.5665529,13.0341297 13.5665529,12.6040956 13.3003413,12.337884 L9.96245734,9 L13.3003413,5.66211604 C13.559727,5.40273038 13.559727,4.96587031 13.3003413,4.70648464 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 18 0 18 18 0 18"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#5697B7",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectionCloseHover);
export default __webpack_public_path__ + "static/media/icon_section_close_hover.862065af7594a704aed3f9b2df9e10e4.svg";
export { ForwardRef as ReactComponent };